<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4" xl="3">
        <v-form @submit="login">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Login</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-text-field
                label="Username"
                name="username"
                prepend-icon="mdi-account"
                type="text"
                required
                v-model="username"
                :error-messages="usernameErrors"
                :disabled="loading"
                @input="$v.username.$touch()"
                @blur="$v.username.$touch()"
              ></v-text-field>

              <v-text-field
                id="password"
                label="Password"
                name="password"
                prepend-icon="mdi-lock"
                type="password"
                required
                v-model="password"
                :error-messages="passwordErrors"
                :disabled="loading"
                @input="$v.password.$touch()"
                @blur="$v.password.$touch()"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" :disabled="loading" :loading="loading" type="submit">Login</v-btn>
            </v-card-actions>
            <v-dialog v-model="loading" hide-overlay persistent disabled width="300">
              <v-card color="primary" dark>
                <v-card-text>
                  กำลังโหลดข้อมูลกรุณารอสักครู่
                  <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  validations: {
    username: { required },
    password: { required },
  },
  components: {},
  data: () => {
    return {
      username: "",
      password: "",
      loading: false,
    };
  },
  created() {
    document.title = "เข้าสู่ระบบ";
  },
  computed: {
    usernameErrors() {
      const errors = [];
      if (!this.$v.username.$dirty) return errors;
      !this.$v.username.required && errors.push("กรุณาใส่ Username");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("กรุณาใส่ Password");
      return errors;
    },
  },
  methods: {
    login(e) {
      e.preventDefault();
      this.$v.$touch();
      if (this.$v.$invalid) return false;
      const paylaod = {
        username: this.username,
        password: this.password,
      };

      this.loading = true;
      this.$store
        .dispatch("auth/login", paylaod)
        .then((res) => {
          if (res.success == true) {
            this.$router.push({
              name: "Home",
            });
          } else if (res.success == false && res.message) {
            this.$notify({
              type: "error",
              title: "Error",
              text: res.message,
            });
          } else {
            this.$notify({
              type: "error",
              title: "Error",
              text: "พบปัญหากับระบบกรุณาลองใหม่อีกครั้งภายหลัง",
            });
          }

          this.loading = false;
        })
        .catch((err) => {
          const errMsg =
            (err &&
              err.response &&
              err.response.data &&
              err.response.data.message) ||
            err.message ||
            "พบปัญหากับระบบกรุณาลองใหม่อีกครั้งภายหลัง";
          this.$notify({
            type: "error",
            title: "Error",
            text: errMsg,
          });
          this.loading = false;
        });
    },
  },
};
</script>
